import React from 'react';
import ReactDOM from 'react-dom/client';
import ConfiguratorApp from './configurator.jsx';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ConfiguratorApp />
  </React.StrictMode>
);
